import { withClientErrorPage } from '@sm/webassets';
import { CannedError } from './CannedError';

export default withClientErrorPage(CannedError, { titularElementTag: 'h1' });
